export default __webpack_public_path__ + "static/media/asmovie-logo.da2175dd.png";